import { Center, Icon, Image, Spinner } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { useState } from 'react'
import { MdOutlineBrokenImage } from 'react-icons/md'
import type { Res } from 'use-http'
import {
  extensionToIconMap,
  getExtensionFromURL,
} from '../../../utils/mediaLibrary'

const BrokenIcon = (
  <Center>
    <Icon as={MdOutlineBrokenImage} boxSize="100%" padding="10%" />
  </Center>
)

const AnalyticsFilePreview = ({
  url,
  forceimagePreview = false
}: {
  url: string
  forceimagePreview?: boolean
}): ReactElement => {
  const [loading, setLoading] = useState<boolean>(true)

  if(forceimagePreview) {
    return (
      <Image
        src={url}
        loading="lazy"
        onLoadedData={() => {
          setLoading(false)
        }}
        onError={() => {
          setLoading(false)
        }}
        fallback={
          loading ? (
            <Center>
              <Spinner />
            </Center>
          ) : (
            BrokenIcon
          )
        }
      />
    )
  }

  const extension = getExtensionFromURL(url)

  if (!extension) {
    return BrokenIcon
  }

  const isVideoJob = url.includes("ik-thumbanil")

  if (!isVideoJob && ['jpg', 'webp', 'jpeg', 'png', 'gif', 'svg', 'avif'].includes(extension)) {
    return (
      <Image
        src={url}
        loading="lazy"
        onLoadedData={() => {
          setLoading(false)
        }}
        onError={() => {
          setLoading(false)
        }}
        fallback={
          loading ? (
            <Center>
              <Spinner />
            </Center>
          ) : (
            BrokenIcon
          )
        }
      />
    )
  }

  const IconComponent = extensionToIconMap[extension] ?? null
  if (!IconComponent) {
    return BrokenIcon
  }

  return (
    <Center>
      <Icon as={IconComponent} boxSize="100%" padding="10%" />
    </Center>
  )
}

export default AnalyticsFilePreview
